import React from "react";
// Styled
import { ItemListContent, ItemListInfo, ItemListDate, ItemListText, ItemListPoints } from "./LoyaltyItemList.styled";
// Material UI
import { CompareArrows as CompareArrowsIcon } from "@material-ui/icons";

export const LoyaltyItemList = ({ item, odd }) => {

    const { value, note, date } = item;
    const type = value >= 0 ? 'Acumulo' : 'Decrescimo';

    return (
        <ItemListContent zebra={odd} type={type}>
            <ItemListInfo>
                <CompareArrowsIcon />
                <ItemListText>
                    <ItemListPoints
                        type={type}>
                        {`${value >= 0 ? '+' : ''}${value} pontos`}
                    </ItemListPoints>
                    {note && (
                        <span>{note}</span>
                    )}
                </ItemListText>
            </ItemListInfo>
            <ItemListDate>
                {date}
            </ItemListDate>
        </ItemListContent>
    )
}